export const DEFAULT_STROKE_COLOR = '#000000'
export const DISABLED_STROKE_COLOR = '#E0E0E0'
export const DEFAULT_ANNOTATION_SIZE = 'default'
export const DEFAULT_LINE_HEIGHT = 10
export const STROKE_COLOR_VARIATIONS = [
  '#808080',
  '#8B4513',
  '#FF8C00',
  '#DAA520',
  '#228B22',
  '#0066CC',
  '#7B3F9E',
  '#C71585',
  '#CC0000',
]
export const STROKE_COLOR_OPTIONS = [
  DEFAULT_STROKE_COLOR,
  ...STROKE_COLOR_VARIATIONS,
]
